export const environment = {
  production: false,
  apiUrl: '',
  apiBaseDomain: 'app-api-staging.prizmwms.com',
  appBaseDomain: 'app-mobile-staging.prizmwms.com',
  devTenantCode: '',
};
